import React from 'react';
import { Gender } from '../../utils/apiClient';
import { AgeCategoriesEditor, WeightCategoriesEditor } from '../CategoryLimitsEditor/CategoryLimitsEditor';
import { AgeCategoryDraft, WeightCategoryDraft } from '../../utils/categoryResolver';
import './GenderedCategoriesSection.scss';

interface GenderedCategoriesSectionProps {
  gender: Gender;
  title: string;
  weightDrafts: WeightCategoryDraft[];
  ageDrafts: AgeCategoryDraft[];
  onWeightChange: (drafts: WeightCategoryDraft[]) => void;
  onAgeChange: (drafts: AgeCategoryDraft[]) => void;
}

export const GenderedCategoriesSection: React.FC<GenderedCategoriesSectionProps> = ({
  gender,
  title,
  weightDrafts,
  ageDrafts,
  onWeightChange,
  onAgeChange,
}) => (
  <section className="gendered-categories-section">
    <h3 className="gendered-categories-section__title">{title}</h3>
    <div className="gendered-categories-section__block">
      <label>Возрастные категории</label>
      <p className="gendered-categories-section__hint">
        Укажите название и верхние пределы возраста для {title.toLowerCase()}. Название используется в протоколе взвешивания.
      </p>
      <AgeCategoriesEditor
        categories={ageDrafts}
        onChange={(drafts) => onAgeChange(drafts.map((d) => ({ ...d, gender })))}
      />
    </div>
    <div className="gendered-categories-section__block">
      <label>Весовые категории</label>
      <p className="gendered-categories-section__hint">Верхние пределы веса в кг для {title.toLowerCase()}.</p>
      <WeightCategoriesEditor
        categories={weightDrafts}
        onChange={(drafts) => onWeightChange(drafts.map((d) => ({ ...d, gender })))}
      />
    </div>
  </section>
);

export const buildGenderedCategoryInputs = (
  boysWeight: WeightCategoryDraft[],
  boysAge: AgeCategoryDraft[],
  girlsWeight: WeightCategoryDraft[],
  girlsAge: AgeCategoryDraft[]
) => ({
  weightCategories: [...boysWeight, ...girlsWeight],
  ageCategories: [...boysAge, ...girlsAge],
});
